import React, { useEffect, useMemo, useState } from 'react'
import { pick } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { SearchTree } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import { listToTree } from '@ow/utils'

const ROOTOBJECTID = `rootnode-${Math.round(Math.random() * 10000)}`

function StandardTree({ standardModel, areaModel }) {
  const [tbData, setTbData] = useState([])
  const [expandedKeys, setExpandedKeys] = useState([])
  const {
    matrixConfig = {},
    setMatrixSelected,
    setFilters,
  } = useTbViewStore((state) =>
    pick(state, ['matrixConfig', 'setMatrixSelected', 'setFilters'])
  )

  const treeData = useMemo(() => {
    return listToTree(tbData)
  }, [tbData])

  useEffect(() => {
    setExpandedKeys([ROOTOBJECTID])
  }, [])

  useEffect(() => {
    const model =
      matrixConfig.matrixSelected === 'area' ? areaModel : standardModel
    const rootNode = {
      isParentNode: true,
      level: 0,
      objectId: ROOTOBJECTID,
      id: ROOTOBJECTID,
      title: '全选',
    }
    model.fetchAll().then((data) => {
      const arr = data.map((v) => {
        if (v.level === 1 && matrixConfig.matrixSelected !== 'area') {
          return {
            ...v,
            id: v.objectId,
            parentId: ROOTOBJECTID,
          }
        }
        return { ...v, id: v.objectId }
      })

      setTbData(
        matrixConfig.matrixSelected !== 'area' ? [rootNode, ...arr] : arr
      )
    })
  }, [matrixConfig])

  const updateMatrixSelected = (ids) => {
    setMatrixSelected(ids)
    if (matrixConfig.matrixSelected === 'area') {
      setFilters({
        logicType: 'and',
        queries: [
          {
            slug: 'area',
            queryType: ['equal'],
            value: ids,
          },
        ],
      })
    }
  }

  const handleSelectChanged = (x) => {
    if (x && x.length > 50 && matrixConfig.matrixSelected === 'area') {
      return showNotification({
        title: '提示',
        message: '最多只能选中50项',
      })
    }
    return updateMatrixSelected(x)
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <SearchTree
        data={treeData}
        expandedKeys={expandedKeys}
        titleLength={50}
        label="title"
        ckey="objectId"
        showLine={false}
        checkable
        onCheck={handleSelectChanged}
        selectable
        onSelect={handleSelectChanged}
        setExtData={(item) => {
          return {
            isLastLevel: item.children.length === 0,
          }
        }}
        onExpand={(keys) => {
          setExpandedKeys(keys)
        }}
        icon={(item) => {
          return item.icon || null
        }}
      />
    </div>
  )
}

export default StandardTree
